import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../config';
import { z } from 'zod';
import { ApiResponse, CustomQueryOptions } from '@/shared/types';

export const getPointSummaryRequestSchema = z.object({
  spaceId: z.number(),
  expireDays: z.number().default(14),
});

export const getPointSummaryResponseSchema = z.object({
  total: z.number(),
  freePlan: z.number(),
  promotion: z.number(),
  paidPurchase: z.number(),
  paidPlan: z.number(),
  expiringPoints: z.number(),
});

export type GetPointSummaryRequestType = z.infer<
  typeof getPointSummaryRequestSchema
>;
export type GetPointSummaryResponseType = z.infer<
  typeof getPointSummaryResponseSchema
>;

type ResponseType = ApiResponse<GetPointSummaryResponseType>;

export const getPointSummaryApi = async (
  request: GetPointSummaryRequestType,
) => {
  const response = await axiosClient.get<ResponseType>(
    `/v1.0/point/summary/${request.spaceId}`,
    {
      params: {
        expireDays: request.expireDays,
      },
    },
  );
  return response.data;
};

export const QueryKeyUseGetPointSummaryApi = 'getPointSummary' as const;

export const useGetPointSummaryApi = (
  request: GetPointSummaryRequestType,
  queryOptions?: CustomQueryOptions<ResponseType>,
) => {
  return useQuery({
    queryKey: [QueryKeyUseGetPointSummaryApi, request],
    queryFn: () => getPointSummaryApi(request),
    ...queryOptions,
  });
};
